<template>
  <div>
    <div v-if="node">
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{node[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "bfr",
  props: {
    node: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["building", "Building"],
      ["floor", "Floor"],
      ["room", "Room"],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
